var map = {
	"./board/corner-bottom-left.png": 336,
	"./board/corner-bottom-right.png": 337,
	"./board/corner-top-left.png": 338,
	"./board/corner-top-right.png": 339,
	"./board/hole.png": 340,
	"./board/plank-bottom.png": 341,
	"./board/plank-left.png": 342,
	"./board/plank-right.png": 343,
	"./board/plank-top.png": 344,
	"./buttons/button-large-border.png": 345,
	"./buttons/button-medium-border.png": 346,
	"./buttons/button-nav-border.png": 347,
	"./flag/flag-normal.png": 348,
	"./flag/flag-ripped.png": 349,
	"./gems/border-default.png": 350,
	"./gems/broken-shadow.png": 351,
	"./gems/gem-blue.png": 352,
	"./gems/gem-bronze.png": 353,
	"./gems/gem-caviar.png": 354,
	"./gems/gem-gold.png": 355,
	"./gems/gem-ice.png": 356,
	"./gems/gem-lava.png": 357,
	"./gems/gem-neutral.png": 358,
	"./gems/gem-red.png": 359,
	"./gems/gem-silver.png": 360,
	"./gems/gem-void.png": 361,
	"./logo.png": 362,
	"./logo/logo-full.png": 363,
	"./panel/panel-border-bottom.png": 364,
	"./panel/panel-border-left.png": 365,
	"./panel/panel-border-right.png": 366,
	"./panel/panel-border-top.png": 367,
	"./round-button/round-button-bg-pressed.png": 368,
	"./round-button/round-button-bg.png": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;